import React, { Component } from 'react';
import {Grid} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker,MuiPickersUtilsProvider } from '@material-ui/pickers';

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldValue: null,
        }
    }
    
    componentDidMount() {
        // console.log('Called cwm for input...');
        // console.log(this.props.editRecord);
        if (this.props.editRecord){
        //    console.log('Called cwm for input...');
           let initVal =  this.props.editRecord[this.props.fieldMap.field];
           if (!initVal){initVal = null}
           this.setState({fieldValue:initVal});
           this.props.setField({field:this.props.fieldMap.field, value:initVal});
        }
    }

    updateValue(new_value) {
        this.setState({fieldValue:new_value});
    }
        
    render() {
        const spec = this.props.fieldMap;      
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid item >
                    <KeyboardDatePicker
                        clearable
                        autoComplete='off'
                        format="yyyy-MM-dd"
                        id={spec.field}
                        label={spec.headerName}
                        value={this.state.fieldValue}
                        onChange={this.handleChange}
                        required={spec.f_required}
                        disabled={this.props.disabled}
                        fullWidth={true}
                        animateYearScrolling={true}
                        autoOk={true}
                        disableFuture={spec.f_disable_future}
                        disablePast={spec.f_disable_past}
                        maxDate={spec.f_max_date}
                        minDate={spec.f_min_date}
                    />
            </Grid>
            </MuiPickersUtilsProvider>
        );
    }

    handleChange = (date,value) => {
        // console.log(date);
        // console.log(value);
        this.setState({fieldValue:value})
        this.props.setField({field:this.props.fieldMap.field, value:value});
    }

}

export default DatePicker;